import PropTypes from 'prop-types';

import { useContext } from 'react';

import MaterialsCaptureContext from '../../context/MaterialsCaptureContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

const JanusMixingForm = ({ data }) => {
  const { handleInputChange, formErrors } = useContext(MaterialsCaptureContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Sample Name"
          name={`lnp_sample_name-${data?.index}`}
          value={data?.lnp_sample_name}
          onChange={e => 
            handleInputChange(e, data?.index, 'lnp_sample_name', e.target.value)
          }
          helperText={formErrors[`lnp_sample_name-${data?.index}`]}
          error={`lnp_sample_name-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Well ID"
          name={`labware_item_location-${data?.index}`}
          value={data?.labware_item_location}
          onChange={e => 
            handleInputChange(e, data?.index, 'labware_item_location', e.target.value)
          }
          helperText={formErrors[`labware_item_location-${data?.index}`]}
          error={`labware_item_location-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Labware Type"
          name={`labware_type-${data?.index}`}
          value={data?.labware_type}
          onChange={e => 
            handleInputChange(e, data?.index, 'labware_type', e.target.value)
          }
          helperText={formErrors[`labware_type-${data?.index}`]}
          error={`labware_type-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Tip Type"
          name={`pipette_tip_type-${data?.index}`}
          value={data?.pipette_tip_type}
          onChange={e => 
            handleInputChange(e, data?.index, 'pipette_tip_type', e.target.value)
          }
          helperText={formErrors[`pipette_tip_type-${data?.index}`]}
          error={`pipette_tip_type-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="AQ Labware"
          name={`rna_labware_item-${data?.index}`}
          value={data?.rna_labware_item}
          onChange={e => 
            handleInputChange(e, data?.index, 'rna_labware_item', e.target.value)
          }
          helperText={formErrors[`rna_labware_item-${data?.index}`]}
          error={`rna_labware_item-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="AQ Well"
          name={`rna_labware_item_location-${data?.index}`}
          value={data?.rna_labware_item_location}
          onChange={e => 
            handleInputChange(e, data?.index, 'rna_labware_item_location', e.target.value)
          }
          helperText={formErrors[`rna_labware_item_location-${data?.index}`]}
          error={`rna_labware_item_location-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Mixing Cycles"
          name={`mixing_cycles-${data?.index}`}
          value={data?.mixing_cycles}
          onChange={e => 
            handleInputChange(e, data?.index, 'mixing_cycles', e.target.value)
          }
          helperText={formErrors[`mixing_cycles-${data?.index}`]}
          error={`mixing_cycles-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Encapsulation Speed"
          name={`encapsulation_speed-${data?.index}`}
          value={data?.encapsulation_speed}
          onChange={e => 
            handleInputChange(e, data?.index, 'encapsulation_speed', e.target.value)
          }
          helperText={formErrors[`encapsulation_speed-${data?.index}`]}
          error={`encapsulation_speed-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Dilution Speed"
          name={`dilution_speed-${data?.index}`}
          value={data?.dilution_speed}
          onChange={e => 
            handleInputChange(e, data?.index, 'dilution_speed', e.target.value)
          }
          helperText={formErrors[`dilution_speed-${data?.index}`]}
          error={`dilution_speed-${data?.index}` in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Sample Replicate"
          name={`lnp_sample_replicate-${data?.index}`}
          value={data?.lnp_sample_replicate}
          onChange={e => 
            handleInputChange(e, data?.index, 'lnp_sample_replicate', e.target.value)
          }
          helperText={formErrors[`lnp_sample_replicate-${data?.index}`]}
          error={`lnp_sample_replicate-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="LNP Plate Barcode"
          name={`lnp_plate_barcode-${data?.index}`}
          value={data?.lnp_plate_barcode}
          onChange={e => 
            handleInputChange(e, data?.index, 'lnp_plate_barcode', e.target.value)
          }
          helperText={formErrors[`lnp_plate_barcode-${data?.index}`]}
          error={`lnp_plate_barcode-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

JanusMixingForm.propTypes = {
  data: PropTypes.object.isRequired,
};

export default JanusMixingForm;